import { getTierOrder } from 'loyalty/lib/tierUtils'

/** Normalises a tier string from Lab or svc-lux-loyalty ("Gold", "gold") to a known App.LoyaltyTier, otherwise undefined */
export function toLoyaltyTier(value: unknown): App.LoyaltyTier | undefined {
  if (typeof value !== 'string') return undefined
  const normalised = value.toLowerCase() as App.LoyaltyTier
  return getTierOrder().includes(normalised) ? normalised : undefined
}
